import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { normalizeSocialLink as n } from "../../utils/normalize-social-link.mjs";
import { getSocialLinkIcon as m } from "../../utils/get-social-link-icon.mjs";
import s from "../../../components/store-image.mjs";
import { useStore as d } from "../../../store/index.mjs";
import { StoreImageEnum as p } from "../../../enums/store-image-enum.mjs";
const u = ({ profile: r, socialLinks: a }) => {
  var o;
  const { locale: t } = d();
  return /* @__PURE__ */ e(
    "section",
    {
      role: "region",
      "aria-labelledby": "region-heading",
      className: "flex w-full max-w-xl flex-col gap-5 px-5 py-10 sm:px-0",
      children: /* @__PURE__ */ i("div", { className: "flex flex-row gap-5", children: [
        /* @__PURE__ */ e("div", { className: "border-3 border-THEME-primary self-start rounded-full", children: /* @__PURE__ */ e(
          s,
          {
            width: 99,
            height: 99,
            imageType: p.profile,
            alt: r.sellerName,
            src: (o = r.sellerPhoto) == null ? void 0 : o.path,
            className: "rounded-full border-2 border-transparent object-cover"
          }
        ) }),
        /* @__PURE__ */ i("div", { className: "flex flex-col justify-between", children: [
          /* @__PURE__ */ e(
            "h1",
            {
              id: "region-heading",
              lang: t,
              className: "text-THEME-primary mb-1 break-all text-[22px] font-bold leading-7",
              children: r.sellerName
            }
          ),
          /* @__PURE__ */ e("span", { lang: t, className: "hyphens-auto mb-2.5 text-[14px] font-normal leading-4", children: r.bio }),
          !!a.length && /* @__PURE__ */ e("div", { className: "flex flex-wrap items-start gap-1.5", children: a.map((l) => /* @__PURE__ */ e(
            "a",
            {
              href: n(l),
              target: "_blank",
              rel: "noreferrer",
              className: "rounded-full bg-[#F1F4F8] p-2",
              "aria-label": l.type,
              children: m(l.type, "fill-THEME-primary")
            },
            l.type
          )) })
        ] })
      ] })
    }
  );
};
export {
  u as ProfileNight
};
